// AutoGenerated
export class TatilTarihModel {
    tarihBaslangic!: Date;
    tarihBitis!: Date;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}